module.exports = __webpack_public_path__ + "static/media/3.e1b52425.wav";


//////////////////
// WEBPACK FOOTER
// ./src/audio/row3/3.wav
// module id = 70
// module chunks = 0